import {Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = ["#", "کاربر", "مباشر", "پشتیبان", "رشته", "گرایش", "وضعیت", "مبلغ", "ایجاد", "پرداخت"];

// Helper function to get status label and color
const getStatusDisplay = (status, completed_full_payment) => {
  const statusMap = {
    'new': { label: "در انتظار تکمیل مدارک", color: "indigo" },
    'waiting': { label: 'در انتظار پرداخت', color: 'amber' },
    'second_waiting': { label: 'در انتظار پرداخت مرحله دوم', color: 'amber' },
    'finish': { label: 'اتمام خدمت', color: 'green' },
    'cancel': { label: status, color: 'red' },
    'payment': {
      label: completed_full_payment === false ? 'بیعانه' : 'پرداخت',
      color: completed_full_payment === false ? 'yellow' : 'green',
    },
  };

  return statusMap[status] || { label: status, color: 'gray' };
};

export function ServiceReportGrid({
                                    serviceReport,
                                    onRowClick,
                                  }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مباشر": "agent_name",
    "پشتیبان": "support_name",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "وضعیت": "status",
    "مبلغ": "price",
    "ایجاد": "created_at",
    "پرداخت": "paid_at",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مباشر": true,
    "پشتیبان": true,
    "رشته": true,
    "گرایش": true,
    "وضعیت": true,
    "مبلغ": true,
    "ایجاد": true,
    "پرداخت": true,
  }

  return (
    <div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden [&_button]:min-w-0 [&_button]:px-1 [&_button]:py-2">
      <table className="w-full table-fixed">
        <colgroup>
          <col className="w-[4%]"/>
          <col className="w-[12%]"/>
          <col className="w-[12%]"/>
          <col className="w-[12%]"/>
          <col className="w-[11%]"/>
          <col className="w-[11%]"/>
          <col className="w-[10%]"/>
          <col className="w-[9%]"/>
          <col className="w-[9%]"/>
          <col className="w-[10%]"/>
        </colgroup>
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-50">
        {serviceReport.length === 0 && (
          <tr>
            <td colSpan={TABLE_HEAD.length} className="py-12 text-center">
              <Typography color="blue-gray" className="font-normal">
                موردی یافت نشد
              </Typography>
            </td>
          </tr>
        )}
        {serviceReport.map(
          ({
             id,
             person_id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             support_id,
             support_name,
             support_phone,
             type,
             field_title,
             branch_title,
             status,
             price,
	             vat_percentage,
	             vat_amount,
	             paid_amount,
	             total_payment_amount,
	             payment_amount,
             created_at,
             paid_at,
             multi_payment,
             completed_full_payment,
             service_steps,
           }, index) => {
            const isLast = index === serviceReport.length - 1;
            const classes = isLast ? "p-2" : "p-2";
            return (
              <tr key={id} onClick={() => onRowClick && onRowClick({
                id,
                person_id,
                person_name,
                person_phone,
                agent_name,
                agent_phone,
                support_id,
                support_name,
                support_phone,
                type,
                field_title,
                branch_title,
                status,
                price,
	                vat_percentage,
	                vat_amount,
	                paid_amount,
	                total_payment_amount,
	                payment_amount,
                created_at,
                paid_at,
                multi_payment,
                completed_full_payment,
                service_steps,
              })} className="cursor-pointer hover:bg-blue-gray-50 transition-colors">

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray" className="textRight break-words">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray" className="textRight break-words">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-2">
                    <Typography
                      color="blue-gray"
                      className={`textRight break-words ${support_name ? "" : "text-blue-gray-400"}`}
                    >
                      {support_name || "ثبت نشده"}
                    </Typography>

                    {support_phone && (
                      <Typography color="blue-gray" className="textRight break-words">
                        {persianNumberFormat(support_phone)}
                      </Typography>
                    )}
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    {(() => {
                      const { label, color } = getStatusDisplay(status, completed_full_payment);
                      return <Chip variant="ghost" value={label} color={color} />;
                    })()}
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-2">
                    <Typography color="blue-gray" className="textRight break-words">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex flex-col justify-center px-2">
                    {created_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(created_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-2">
                    {paid_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}
